<template>
  <div class="menuBox">
    <div class="menuBox-top" :title="isCollapse ? '展开' : '收起'">
      <i
        :class="!isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
        @click="isCollapseMethods"
      ></i>
    </div>

    <el-menu
      class="el-menu"
      background-color="transparent"
      text-color="#ffffff"
      router
      :unique-opened="true"
      :default-active="$route.path"
      :collapse="isCollapse"
    >
      <sideBar :menuList="menuList" />
    </el-menu>
  </div>
</template>

<script>
import { menuList } from "@/api/apifoxInterface";
import { arrayToTree } from "@/utils/arrayToTree";

export default {
  name: "menuBox",
  components: {},
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuList: [],
      helpMenuList: require("@/lib/json/apifox/menuList.json"),
    };
  },
  methods: {
    getMenuList() {
      menuList().then((res) => {
        if (res.data.code === 200) {
          this.menuList = arrayToTree(res.data.data);
        }

        if (res.data.code === 504) {
          /* 网络错误，使用本地数据 */
          this.menuList = arrayToTree(this.helpMenuList.data);
        }
      });
    },

    isCollapseMethods() {
      this.$parent.changeIsCollapse();
    },
  },
  created() {
    this.getMenuList();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.menuBox {
  &-top {
    height: 30px;
    padding: 0 10px !important;

    ::v-deep .el-icon-s-fold,
    ::v-deep .el-icon-s-unfold {
      cursor: pointer;
    }
  }
}
</style>
